import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, MapPin, Mail, ArrowUpRight } from 'lucide-react';
import { CONTACT_EMAIL, NAV_LINKS, CLUBS, LOGO } from '../data/mock';

export default function Footer() {
  return (
    <footer className="bg-[#070707] border-t border-[#1c1c1c] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-1">
            <span className="flex items-center gap-2.5">
              <img src={LOGO} alt="Hybrid Training Club" loading="lazy" decoding="async" className="h-11 w-11 object-contain" />
              <span className="font-display text-2xl">HYBRID<span className="text-gold">.</span></span>
            </span>
            <p className="text-[var(--hx-muted)] text-sm mt-4 leading-relaxed">
              Le club Hyrox de Toulouse & Colomiers. Une communauté, deux salles, une seule obsession : ta performance.
            </p>
            <div className="flex gap-3 mt-5">
              {[{ Icon: Instagram, label: 'Instagram', href: 'https://www.instagram.com/hybrid_training.club/' }].map(({ Icon, label, href }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-10 h-10 grid place-items-center border border-[#262626] rounded-full hover:border-accent hover:text-accent transition-colors">
                  <Icon size={17} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-cond tracking-widest text-sm text-white mb-4">Navigation</h4>
            <ul className="space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-[var(--hx-muted)] text-sm hover:text-accent transition-colors">{l.label}</Link>
                </li>
              ))}
              <li><Link to="/contact" className="text-[var(--hx-muted)] text-sm hover:text-accent transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-cond tracking-widest text-sm text-white mb-4">Nos salles</h4>
            <ul className="space-y-4">
              {Object.values(CLUBS).map((c) => (
                <li key={c.slug} className="text-sm">
                  <p className="text-white font-medium">{c.name}</p>
                  <p className="text-[var(--hx-muted)] flex items-start gap-1 mt-1"><MapPin size={14} className="mt-0.5 text-accent shrink-0" />{c.address}</p>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-cond tracking-widest text-sm text-white mb-4">Réserve ta séance</h4>
            <p className="text-[var(--hx-muted)] text-sm mb-4">Première séance offerte. On te recontacte sous 24h.</p>
            <a href={`mailto:${CONTACT_EMAIL}`} className="inline-flex items-center gap-2 text-accent text-sm hover:underline">
              <Mail size={16} /> {CONTACT_EMAIL}
            </a>
            <Link to="/contact" className="hx-btn mt-5 text-sm">
              Je m'inscris <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>

        <div className="border-t border-[#1c1c1c] pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[var(--hx-muted)] text-xs">© {new Date().getFullYear()} Hybrid Training Club. Tous droits réservés.</p>
          <p className="text-[var(--hx-muted)] text-xs">Mentions légales · Politique de confidentialité</p>
        </div>
      </div>
    </footer>
  );
}
